/**
 * Format a user's credit balance for display.
 * Shows ∞ for users with unlimited_credits flag (founders).
 */
export function formatCredits(user, opts = {}) {
  if (!user) return opts.zero ?? '0';
  if (user.unlimited_credits) return '∞';
  const n = Number(user.credits || 0);
  if (opts.decimals === 1) return n.toFixed(1);
  return n.toFixed(0);
}

/** Returns true when the user has the unlimited flag set */
export function isUnlimitedUser(user) {
  return !!(user && user.unlimited_credits);
}
